export const PROBABILITIES = [
  { NAME: 'Hot', COLOR: '#ec7777' },
  { NAME: 'Warm', COLOR: '#fa9c5d' },
  { NAME: 'Cold', COLOR: '#66a3cf' },
];
